export default "__VITE_ASSET__Dy6Jaar3__"